import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeliveryServiceType as LinkDeliveryServiceType } from '../links/DeliveryServiceType';
import { type DeliveryLabelFormatType as SchemaDeliveryLabelFormatType } from '../schemas/DeliveryLabelFormatType';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Orders
 * @summary Получить PDF-штрихкоды заказов в рамках забора груза
 */
export const GetWarehouseDeliveryIntakeLabelsContentType = '' as const;
export type GetWarehouseDeliveryIntakeLabelsRequest = void;
export type GetWarehouseDeliveryIntakeLabelsResponses = LinkCommonErrorResponses & {
    /**
     * @description Intake labels PDF archive
     */
    '200': {
        'application/zip': string;
    };
};
export type GetWarehouseDeliveryIntakeLabelsResponseSuccess =
    GetWarehouseDeliveryIntakeLabelsResponses['200']['application/zip'];
export type GetWarehouseDeliveryIntakeLabelsSearchParams = {
    service_type: LinkDeliveryServiceType;
    label_format?: SchemaDeliveryLabelFormatType;
    from: string;
    to: string;
};
export type GetWarehouseDeliveryIntakeLabelsPathParameters = {
    warehouse_id: string;
};
export const GetWarehouseDeliveryIntakeLabelsUrl = '/warehouses/{warehouse_id}/delivery/intakes/labels' as const;
export const GetWarehouseDeliveryIntakeLabelsMethod = 'GET' as const;
export const getGetWarehouseDeliveryIntakeLabelsUrl = (params: GetWarehouseDeliveryIntakeLabelsPathParameters) =>
    GetWarehouseDeliveryIntakeLabelsUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof GetWarehouseDeliveryIntakeLabelsPathParameters) => String(params[param])
    );
